/* eslint-disable vue/multi-word-component-names */
import { createApp } from 'vue'
import App from './App'
import Router from './router'
import Store from '@/store/index'
import Form from '@/shared//Form'
import Errors from '@/shared/Errors'

import 'primeflex/primeflex.css';

//Primevue
import * as primevueComponents from './primevue-components';
import PrimeVue from "primevue/config";

import '@/assets/scss/corefive-styles.scss';
import '@/assets/css/corefive.css';

window.Form     = Form;
window.Errors   = Errors;

const app = createApp(App)
app.use(Router)
app.use(Store)
app.use(PrimeVue)

// Register the components globally
// app.component('Avatar', primevueComponents.Avatar)
// app.component('BlockUI', primevueComponents.BlockUI)
// app.component('Breadcrumb', primevueComponents.Breadcrumb)
// app.component('Button', primevueComponents.Button)
// app.component('Calendar', primevueComponents.Calendar)
// app.component('Card', primevueComponents.Card)
// app.component('Checkbox', primevueComponents.Checkbox)
// app.component('ColorPicker', primevueComponents.ColorPicker)
// app.component('Column', primevueComponents.Column)
// app.component('DataTable', primevueComponents.DataTable)
// app.component('DataView', primevueComponents.DataView)
// app.component('DataViewLayoutOptions', primevueComponents.DataViewLayoutOptions)
// app.component('Divider', primevueComponents.Divider)
// app.component('Dialog', primevueComponents.Dialog)
// app.component('Dropdown', primevueComponents.Dropdown)
// app.component('Editor', primevueComponents.Editor)
// app.component('Fieldset', primevueComponents.Fieldset)
// app.component('FilterMatchMode', primevueComponents.FilterMatchMode)
// app.component('FilterService', primevueComponents.FilterService)
// app.component('Image', primevueComponents.Image)
// app.component('InlineMessage', primevueComponents.InlineMessage)
// app.component('InputNumber', primevueComponents.InputNumber)
// app.component('InputText', primevueComponents.InputText)
// app.component('Menu2', primevueComponents.Menu)
// app.component('Menubar', primevueComponents.Menubar);
// app.component('MultiSelect', primevueComponents.MultiSelect)
// app.component('Message', primevueComponents.Message)
// app.component('Panel', primevueComponents.Panel)
// app.component('Paginator', primevueComponents.Paginator)
// app.component('Password', primevueComponents.Password)
// app.component('RadioButton', primevueComponents.RadioButton)
// app.component('Rating', primevueComponents.Rating)
// app.component('SelectButton', primevueComponents.SelectButton)
// app.component('Sidebar', primevueComponents.Sidebar)
// app.component('Splitbutton', primevueComponents.SplitButton)
// app.component('TabView', primevueComponents.TabView)
// app.component('TabPanel', primevueComponents.TabPanel)
// app.component('Tag', primevueComponents.Tag)
// app.component('Textarea', primevueComponents.Textarea)
// app.component('Toast', primevueComponents.Toast)
// app.component('ToggleButton', primevueComponents.ToggleButton)
// app.component('Toolbar', primevueComponents.Toolbar)
// app.component('TreeTable', primevueComponents.TreeTable)
// app.component('TriStateCheckbox', primevueComponents.TriStateCheckbox)

Object.keys(primevueComponents).forEach((key) => {
    app.component(key, primevueComponents[key]);
});

app.mount('#app')
